import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { Info } from "../styled/texts";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import { useQuery } from "react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { TabInfo } from "./TabInfo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  padding: 20px 30px;
`;

const ProfileDataPoints = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

const StyledLabelValueRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const StyledLabel = styled.div`
  flex-basis: 20%;
  color: #3d4253;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const StyledValue = styled.div`
  flex-basis: 80%;
  color: rgba(110, 110, 110, 0.93);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150.188%; /* 24.03px */
`;

const dataKeys = [
  {
    type: "no-label",
    key: "logo",
    key1: "name",
  },
  {
    label: "Business Name",
    key: "name",
  },
  {
    label: "Email",
    key: "email",
  },
  {
    label: "Address",
    key: "address",
  },
  {
    label: "About",
    key: "desc",
  },
];

const getDataFromKey = (data, key) => {
  if (!(data && data.data && data.data.data && data.data.data.orgDetails)) {
    return <span style={{ color: "#D04222" }}>Not added</span>;
  }
  return data.data.data.orgDetails[key] ? (
    data.data.data.orgDetails[key]
  ) : (
    <span style={{ color: "#D04222" }}>Not added</span>
  );
};

const dataIsNotNull = (data) => {
  return data && data.data && data.data.data && data.data.data.orgDetails;
};

const Profile = (props) => {
  const token = Cookies.get("jwt_token");
  const { isLoading, error, data } = useQuery(
    "sampleData",
    () => {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      return axios
        .get("http://localhost:3000/api/v1/org/orgDetails", config)
        .then((response) => {
          // console.log("Offerings: ", response);
          return response;
          // setOrgOfferings([...response.data.offerings]);
        })
        .catch((error) => {
          // console.log("Offerings error: ", error);
          return error;
        });
    }
    // org/orgDetails
  );

  if (isLoading) return "loading...";

  if (error) return "error occured: " + error.message;

  // if (data) console.log("response data:", data.data.data.orgDetails);

  return (
    <Container>
      <TabInfo
        header={"Business Profile"}
        desc={`This page displays the information about your organization. You can view
        details such as location, contact information, and description of the
        business.`}
        editIcon={true}
      />
      <VerticalGap size={"20px"} />
      <ProfileDataPoints>
        {dataIsNotNull(data)
          ? dataKeys.map((dataKey, idx) => {
              if (dataKey.type == "no-label") {
                return (
                  <>
                    <StyledLabelValueRow key={idx}>
                      <StyledLabel>
                        <img
                          src={getDataFromKey(data, dataKey.key)}
                          style={{ width: 100, borderRadius: 50 }}
                        />
                      </StyledLabel>
                      <HorizontalGap size={"20px"}></HorizontalGap>
                      <StyledValue>
                        {getDataFromKey(data, dataKey.key1)}
                      </StyledValue>
                    </StyledLabelValueRow>
                    <VerticalGap key={"Gap_" + idx} size={"20px"} />
                  </>
                );
              }
              return (
                <>
                  <StyledLabelValueRow key={idx}>
                    <StyledLabel>{dataKey.label}</StyledLabel>
                    <HorizontalGap size={"20px"}></HorizontalGap>
                    <StyledValue>
                      {getDataFromKey(data, dataKey.key)}
                    </StyledValue>
                  </StyledLabelValueRow>
                  {idx !== dataKeys.length - 1 ? (
                    <VerticalGap key={"Gap_" + idx} size={"20px"} />
                  ) : null}
                </>
              );
            })
          : null}
      </ProfileDataPoints>
    </Container>
  );
};

export { Profile };
